import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Template from '../../component/Template';
import Api from '../../component/Api';
import useAuth from '../../component/useAuth';
import Select from 'react-select';

const ITEMS_PER_PAGE = 50;

export default function Convenor_SignatureCourseList() {
	const navigate = useNavigate();
	const isAuth = useAuth();
	const { http } = Api();

	const [loading, setLoading] = useState(false);
	const [courseData, setCourseData] = useState([]);
	const [searchQuery, setSearchQuery] = useState('');
	const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' });
	const [currentPage, setCurrentPage] = useState(1);
	const [selectedCourse, setSelectedCourse] = useState(null);
	const [showCourseModal, setShowCourseModal] = useState(false);
	const [actionLoadingId, setActionLoadingId] = useState(null);
	const [newRemark, setNewRemark] = useState('');
	const [getSignatureCourseData, setSignatureCourseData] = useState([]);
	const [getOtherSignatureCourseData, setOtherSignatureCourseData] = useState([]);
	const [getCollegesData, setCollegesData] = useState([]);
	const [getSpecializationsData, setSpecializationsData] = useState([]);
	const [getDisciplinesData, setDisciplinesData] = useState([]);
	const [changedCollegeData, setChangedCollegeData] = useState(null);
	const [changedCollegesId, setChangedCollegesId] = useState(null);
	const [changedCollegeName, setChangedCollegeName] = useState(null);
	const [changedSpecializationData, setChangedSpecializationData] = useState(null);
	const [changedSpecializationId, setChangedSpecializationId] = useState(null);
	const [changedDisciplineData, setChangedDisciplineData] = useState(null);
	const [changedDisciplineId, setChangedDisciplineId] = useState(null);
	const [changedStatusData, setChangedStatusData] = useState(null);
	const [changedStatusId, setChangedStatusId] = useState(null);
	const [searchClicked, setSearchClicked] = useState(false);
	const [clearClicked, setClearClicked] = useState(false);
	const [displayCollegeName, setDisplayCollegeName] = useState(false);
	const [selectedAdmissionYearID, setSelectedAdmissionYearID] = useState(null);
	const [selectedAdmissionYear, setSelectedAdmissionYear] = useState(null);
	const [refresh] = useState(false);

	const getStatusBadgeClass = (status) => {
		const statusMap = {
			entered: 'bg-secondary',
			forwareded_to_principal: 'bg-info text-dark',
			teacher_submited: 'bg-primary',
			principal_forwarded: 'bg-success',
			principal_forwarded_aca12: 'bg-success',
			principal_reverted: 'bg-warning text-dark',
			aca12_forwarded_to_expert_committee: 'bg-info text-dark',
			aca12_reverted_to_teacher: 'bg-warning text-dark',
			aca12_reverted_to_expert: 'bg-danger',
			expert_reverted_to_teacher: 'bg-danger',
			expert_recommended_to_aca12: 'bg-success',
			expert_rejected_course: 'bg-reject-txt',
		};

		return statusMap[status] || 'bg-secondary';
	};

	const getStatusText = (status) => {
		const statusTextMap = {
			entered: 'Draft',
			forwareded_to_principal: 'Forwarded to Principal',
			teacher_submited: 'Entry Completed',
			principal_forwarded: 'Principal Forwarded',
			principal_forwarded_aca12: 'Principal Forwarded to ACA12',
			principal_reverted: 'Principal Reverted',
			aca12_forwarded_to_expert_committee: 'Forwarded by ACA12 to Expert Committee',
			aca12_reverted_to_teacher: 'ACA12 Reverted to Teacher',
			aca12_reverted_to_expert: 'ACA12 Reverted to Convenor',
			expert_reverted_to_teacher: 'Expert Reverted to Teacher',
			expert_recommended_to_aca12: 'Recommended to ACA12',
			expert_rejected_course: 'Expert Rejected Course',
		};

		return statusTextMap[status] || status?.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) || 'N/A';
	};

	useEffect(() => {
		if (isAuth === false) {
			navigate('/convenor/');
		}
	}, [isAuth, navigate]);

	const fetchForwardedCourseList = async () => {
		const college_id = changedCollegesId ? changedCollegesId : 0;
		const special_id = changedSpecializationId === undefined || changedSpecializationId === null ? '' : changedSpecializationId;
		const discipline_id = changedDisciplineId ? changedDisciplineId : 0;
		const entry_status = changedStatusId ? changedStatusId : 0;
		setLoading(true);
		setCourseData([]);
		try {
			const response = await http.get('/convenor/aca12ForwardedSignatureCourseList', {
				params: {
					admission_year: selectedAdmissionYearID || null,
					specialisation_id: special_id,
					discipline_id,
					entry_status,
				},
			});

			const apiData = response?.data?.data ?? [];
			setCourseData(Array.isArray(apiData) ? apiData : []);
			setSignatureCourseData(response?.data?.signature_course ?? []);
			setOtherSignatureCourseData(response?.data?.other_signature_course ?? []);
			setDisplayCollegeName(college_id !== 0 && college_id !== null && !!response?.data?.data);
		} catch (error) {
			const res = error?.response?.data;

			if (res?.http_status === 403 && res.status_code === 'ERR37') {
				toast.error('Invalid Token');
				setTimeout(() => {
					navigate('/convenor/');
				}, 3000);
			} else if (res?.http_status === 429 && res.status_code === 'ERR33') {
				toast.error(res.message);
			} else {
				setCourseData([]);
			}
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchForwardedCourseList();
	}, [refresh, searchClicked, clearClicked]);

	useEffect(() => {
		const college_id = changedCollegesId ? changedCollegesId : 0;
		const fetchFiltersList = async () => {
			try {
				const response = await http.get('/Admin/getSignatureCourseListForConvenorFilter', {
					params: { college_id, fetchType: 'bVoc' },
				});

				setCollegesData(response?.data?.colleges || []);
				const specialData = response?.data?.specialisations || [];
				setDisciplinesData(response?.data?.disciplines || []);
				if (!specialData || specialData.length === 0) {
					setSpecializationsData([{ ugp_specialisation_id: '-1', ugp_specialisation_name: 'No Specialization Course Added' }]);
				} else {
					setSpecializationsData(specialData);
				}
			} catch (error) {
				const res = error?.response?.data;
				if (res?.http_status === 403 && res.status_code === 'ERR37') {
					toast.error('Invalid Token');
					setTimeout(() => {
						navigate('/convenor/');
					}, 3000);
				} else if (res?.http_status === 429 && res.status_code === 'ERR33') {
					toast.error(res.message);
				} else {
					toast.error(res?.message || 'An error occurred.');
				}
			}
		};

		fetchFiltersList();
	}, [navigate, changedCollegesId]);

	useEffect(() => {
		setSpecializationsData((prev) => {
			const alreadyExists = prev.some((item) => item.ugp_specialisation_id === 0);
			if (!alreadyExists) {
				return [...prev, { ugp_specialisation_id: 0, ugp_specialisation_name: 'Other Signature Course' }];
			}
			return prev;
		});
	}, [getSpecializationsData]);

	const getCourseDetails = async (id) => {
		try {
			const response = await http.get('Admin/getSignatureCourseDetails', {
				params: { id },
			});

			const data = response?.data;
			setShowCourseModal(true);
			setSelectedCourse({
				id: data.id,
				courseid: data.id,
				name: data.course_name,
				course_name: data.course_name,
				course_code: data.course_code,
				semester: data.semester,
				remarks: JSON.parse(data.remarks || '[]'),
				status: data.entry_status,
				entry_status: data.entry_status,
			});
		} catch (error) {
			setShowCourseModal(false);
			const res = error?.response?.data;

			if (res?.http_status === 403 && res.status_code === 'ERR37') {
				toast.error('Invalid Token');
				setTimeout(() => {
					navigate('/convenor/');
				}, 3000);
			} else if (res?.http_status === 429 && res.status_code === 'ERR33') {
				toast.error(res.message);
			} else {
				toast.error(res?.message || 'Something went wrong.');
			}
		}
	};

	const handleadmissionyear = (selectedOptions) => {
		setSelectedAdmissionYearID(selectedOptions?.value || null);
		setSelectedAdmissionYear(selectedOptions);
	};

	const handleCollegeChange = (selectedOption) => {
		setChangedCollegeData(selectedOption);
		setChangedCollegesId(selectedOption?.value || null);
		setChangedCollegeName(selectedOption?.label || null);
	};

	const handleSpecializationChange = (selectedOption) => {
		setChangedSpecializationData(selectedOption);
		setChangedSpecializationId(selectedOption?.value || null);
	};

	const handleDisciplineChange = (selectedOption) => {
		setChangedDisciplineData(selectedOption);
		setChangedDisciplineId(selectedOption?.value || null);
	};

	const handleStatusChange = (selectedOption) => {
		setChangedStatusData(selectedOption);
		setChangedStatusId(selectedOption?.value || null);
	};

	const allStatusMap = {
		expert_recommended_to_aca12: 'Recommended to ACA12',
		expert_reverted_to_teacher: 'Reverted to Teacher',
		expert_rejected_course: 'Expert Rejected Course',
	};

	const statusOptions = Object.entries(allStatusMap).map(([value, label]) => ({
		value,
		label,
	}));

	const handleClearFields = () => {
		setChangedCollegeData(null);
		setChangedCollegesId(null);
		setChangedCollegeName(null);
		setChangedSpecializationData(null);
		setChangedSpecializationId(null);
		setChangedDisciplineData(null);
		setChangedDisciplineId(null);
		setChangedStatusData(null);
		setChangedStatusId(null);
		setSelectedAdmissionYearID(null);
		setSelectedAdmissionYear(null);
		setDisplayCollegeName(false);
		setClearClicked((prev) => !prev);
	};

	const showCourseList = () => {
		setSearchClicked((prev) => !prev);
	};

	const customStyles = {
		control: (base) => ({
			...base,
			minHeight: '36px',
		}),
		menu: (base) => ({
			...base,
			zIndex: 9999,
		}),
	};

	const handleApproveCourse = async (item) => {
		if (!newRemark.trim()) {
			toast.error('Please enter a remark');
			return;
		}

		setActionLoadingId(item.id);
		try {
			await http.get('/convenor/recommendCourseListForAca12ByExpert', {
				params: { id: item.courseid || item.id, remark: newRemark.trim() },
			});
			toast.success('Course recommended to ACA12 successfully');
			setShowCourseModal(false);
			setSelectedCourse(null);
			setNewRemark('');
			fetchForwardedCourseList();
		} catch (error) {
			const res = error?.response?.data;
			toast.error(res?.message || 'Failed to recommend course');
		} finally {
			setActionLoadingId(null);
		}
	};

	const handleRevertCourse = async (item) => {
		if (!newRemark.trim()) {
			toast.error('Please enter a remark');
			return;
		}

		setActionLoadingId(item.id);
		try {
			await http.get('/convenor/revertCourseListForTeacherByConvenor', {
				params: { id: item.courseid || item.id, remark: newRemark.trim() },
			});
			toast.success('Course reverted to teacher successfully');
			setShowCourseModal(false);
			setSelectedCourse(null);
			setNewRemark('');
			fetchForwardedCourseList();
		} catch (error) {
			const res = error?.response?.data;
			toast.error(res?.message || 'Failed to revert course');
		} finally {
			setActionLoadingId(null);
		}
	};
	  const handleGeneratePDF = async (id, ctype) => {
        setLoading(true);
        try {
            const response = await http.get('/convenor/teacherSignatureCoursePreview', {
                params: {
                    id: id,
                    course_type: ctype
                },
                responseType: 'blob',
            });
            if (response && response.data) {
                // Create a URL for the downloaded file
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                // Set the file name and download the PDF
                link.setAttribute('download', `${localStorage.getItem('username')}_.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setLoading(false);
                return Promise.resolve('PDF generated successfully');
            }
        } catch (error) {
            setLoading(false);
            console.error('Error generating PDF:', error);
            return Promise.reject('Error generating PDF');
        }
    };

	const filteredAndSortedData = useMemo(() => {
		const query = searchQuery.toLowerCase();
		const filtered = [...courseData].filter((item) => (
			item?.ugp_specialisation_name?.toLowerCase().includes(query) ||
			item?.course_name?.toLowerCase().includes(query) ||
			item?.discipline_name?.toLowerCase().includes(query) ||
			item?.admn_year?.toString().includes(searchQuery) ||
			item?.faculty_name?.toLowerCase().includes(query)
		));

		if (!sortBy.column) {
			return filtered;
		}

		return filtered.sort((a, b) => {
			const aValue = a?.[sortBy.column] ?? '';
			const bValue = b?.[sortBy.column] ?? '';

			if (sortBy.direction === 'asc') {
				return aValue > bValue ? 1 : -1;
			}
			return aValue < bValue ? 1 : -1;
		});
	}, [courseData, searchQuery, sortBy]);

	const totalCount = filteredAndSortedData.length;
	const totalPages = Math.max(1, Math.ceil(totalCount / ITEMS_PER_PAGE));

	const paginatedData = useMemo(() => {
		const start = (currentPage - 1) * ITEMS_PER_PAGE;
		return filteredAndSortedData.slice(start, start + ITEMS_PER_PAGE);
	}, [currentPage, filteredAndSortedData]);

	useEffect(() => {
		setCurrentPage(1);
	}, [searchQuery]);

	useEffect(() => {
		if (currentPage > totalPages) {
			setCurrentPage(totalPages);
		}
	}, [currentPage, totalPages]);

	const handleSort = (column) => {
		setSortBy((prev) => ({
			column,
			direction: prev.column === column && prev.direction === 'asc' ? 'desc' : 'asc',
		}));
	};

	const renderSortIcon = (columnName) => {
		if (sortBy.column === columnName) {
			return sortBy.direction === 'asc'
				? <i className="fa fa-sort-up ms-1" aria-hidden="true"></i>
				: <i className="fa fa-sort-down ms-1" aria-hidden="true"></i>;
		}
		return <i className="fa fa-sort ms-1" aria-hidden="true"></i>;
	};

	const startEntry = totalCount === 0 ? 0 : (currentPage - 1) * ITEMS_PER_PAGE + 1;
	const endEntry = Math.min(currentPage * ITEMS_PER_PAGE, totalCount);
	const selectedCourseStatus = selectedCourse?.status || selectedCourse?.entry_status;

	return (
		<>
			<ToastContainer />
			<Template>
				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<div className="card">
								<div className="card-header">
									<div className="py-3 d-flex justify-content-between align-items-center">
										<h5>Signature Courses Forwarded by ACA12</h5>
									</div>
								</div>

								<div className="card-body">
									<div className="card-body">
										<div className="row">
											<div className="col-md-2">
												<label>Admission Year </label>
												<Select
													maxMenuHeight={200}
													menuPlacement="auto"
													id="Adimission_year"
													name="Adimission_year"
													className="form"
													styles={customStyles}
													options={Array.from({ length: new Date().getFullYear() - 2024 }, (_, i) => ({
														value: String(2025 + i),
														label: String(2025 + i),
													}))}
													value={selectedAdmissionYear}
													onChange={handleadmissionyear}
												/>
											</div>
											{/* <div className="col-md-3">
												<label>College </label>
												<Select
													maxMenuHeight={200}
													menuPlacement="auto"
													id="college_id"
													name="college_id"
													className="form"
													styles={customStyles}
													value={changedCollegeData}
													options={getCollegesData && getCollegesData.map((college) => ({
														value: college.college_id,
														label: college.college_name,
													}))}
													onChange={handleCollegeChange}
												/>
											</div> */}

											<div className="col-md-3">
												<label>Specialization</label>
												<Select
													maxMenuHeight={200}
													menuPlacement="auto"
													id="specialization_id"
													name="specialization_id"
													className="form"
													styles={customStyles}
													value={changedSpecializationData}
													options={getSpecializationsData && getSpecializationsData.map((spec) => ({
														value: spec.ugp_specialisation_id,
														label: spec.ugp_specialisation_name.trim(),
														isDisabled: spec.ugp_specialisation_id == -1,
													}))}
													onChange={handleSpecializationChange}
												/>
											</div>

											<div className="col-md-2">
												<label>Discipline </label>
												<Select
													maxMenuHeight={200}
													menuPlacement="auto"
													id="discipline_id"
													name="discipline_id"
													className="form"
													styles={customStyles}
													value={changedDisciplineData}
													options={getDisciplinesData && getDisciplinesData.map((discipline) => ({
														value: discipline.discipline_id,
														label: discipline.discipline_name,
													}))}
													onChange={handleDisciplineChange}
												/>
											</div>

											<div className="col-md-2">
												<label>Status</label>
												<Select
													maxMenuHeight={200}
													menuPlacement="auto"
													id="status_id"
													name="status_id"
													className="form"
													styles={customStyles}
													value={changedStatusData}
													options={statusOptions}
													onChange={handleStatusChange}
													defaultValue=""
												/>
											</div>
											<div className="col-md-12 mt-2">
												<div className="d-flex justify-content-end gap-2">
													<button
														type="button"
														className="btn btn-primary action-btn"
														onClick={showCourseList}
													>
														Go
													</button>

													<button
														type="button"
														className="btn btn-secondary clear-btn btn-sm"
														onClick={handleClearFields}
													>
														Clear
													</button>
												</div>
											</div>
										</div>
									</div>
									
									<div className="row mb-3">
										<div className="col-md-6">
											<p className="mb-0">
												Showing {startEntry}-{endEntry} of {totalCount} entries
											</p>
											{displayCollegeName && changedCollegeName && (
												<small className="text-muted">Selected college: {changedCollegeName}</small>
											)}
										</div>
										<div className="col-md-6" align="right">
											<input
												type="text"
												value={searchQuery}
												onChange={(event) => setSearchQuery(event.target.value)}
												placeholder="Search..."
												className="form-control"
											/>
										</div>
									</div>

									<div className="table-responsive">
										<table className="display dataTable table-striped table-bordered ex-v-table">
											<thead>
												<tr className="bg-primary">
													<th onClick={() => handleSort('admn_year')} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
														Admission Year {renderSortIcon('admn_year')}
													</th>
													<th onClick={() => handleSort('created_on')} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
														Coordinator / Created On {renderSortIcon('created_on')}
													</th>
													<th onClick={() => handleSort('discipline_name')} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
														Discipline {renderSortIcon('discipline_name')}
													</th>
													<th onClick={() => handleSort('ugp_specialisation_name')} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
														Specialisation {renderSortIcon('ugp_specialisation_name')}
													</th>
													<th style={{ textAlign: 'center', verticalAlign: 'middle' }}>
														Semester - Course Name
													</th>
													<th style={{ textAlign: 'center', verticalAlign: 'middle' }}>
														Action
													</th>
												</tr>
											</thead>
											<tbody>
												{!loading && paginatedData.length > 0 && paginatedData.map((item) => (
													<tr key={item.id}>
														<td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{item.admn_year || 'N/A'}</td>
														<td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
															{item.faculty_name || 'N/A'} ({item.created_on || 'N/A'})
														</td>
														<td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{item.discipline_name || 'N/A'}</td>
														<td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{item.ugp_specialisation_name || 'N/A'}</td>
														<td style={{ textAlign: 'left', verticalAlign: 'middle' }}>
															<ul className="course-list-li ps-3 mb-0">
																{(item.course_name?.split('|') || []).map((course, idx) => {
																	const courseIds = typeof item.id === 'string' ? item.id.split('|') : [item.id];
																	const courseId = courseIds[idx] ?? item.id;
																	const statuses = typeof item.entry_status === 'string' ? item.entry_status.split('|') : [item.entry_status];
																	const rawStatus = (statuses[idx] ?? item.entry_status ?? 'aca12_forwarded_to_expert_committee')?.toString().trim();
																	const badgeClass = getStatusBadgeClass(rawStatus);

																	return (
																		<li key={idx} className="course-item-li" style={{ cursor: 'pointer' }} onClick={() => getCourseDetails(courseId)}>
																			<div className="pdg16">{course?.trim()}</div>
																			<div className="pdg17">
																				<span className={`badge ${badgeClass}`} style={{ fontSize: '0.8rem' }}>
																					{getStatusText(rawStatus)}
																				</span>
																			</div>
																		</li>
																	);
																})}
															</ul>
														</td>
														<td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
															 <div className="icon-button1 download-button" title='Download PDF' onClick={() => handleGeneratePDF(item.id, item.course_type)}>
                                                              <i className="bi bi-download" title='Download PDF'></i>
                                                              </div>
														</td>
													</tr>
												))}

												{loading && (
													<tr>
																<td colSpan="6" className="text-center py-3">Loading...</td>
													</tr>
												)}

												{!loading && paginatedData.length === 0 && (
													<tr>
																<td colSpan="6" className="text-center py-3">No Data Found</td>
													</tr>
												)}
											</tbody>
										</table>
									</div>

									{showCourseModal && (
										<div className="modal-backdrop" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.3)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1050 }}>

											<div
												className="modal-content"
												style={{
													width: '500px',
													maxWidth: '95%',
													maxHeight: '90vh',
													display: 'flex',
													flexDirection: 'column',
													backgroundColor: '#f8f9fa',
													borderRadius: '8px',
													border: '1px solid #dee2e6',
													boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
												}}
											>
												<div className="modal-header" style={{ padding: '1rem', borderBottom: '1px solid #dee2e6', backgroundColor: '#e9ecef', position: 'sticky', top: 0, zIndex: 1 }}>
													<h5 className="modal-title m-0" style={{ color: '#495057', fontSize: '1.1rem' }}>
														<i className="bi bi-book me-2"></i>Course Details
													</h5>
													<button
														type="button"
														className="btn-close"
														onClick={() => { setShowCourseModal(false); setSelectedCourse(null); setNewRemark(''); }}
														aria-label="Close"
													/>
												</div>
												<div
													className="modal-body p-0 activity-scroll-container activity-scroll-bar-container clg-card-ht"
													style={{ overflowY: 'auto', flex: 1 }}
												>
													{selectedCourse && (
														<table className="table table-bordered m-0">
															<tbody>
																<tr>
																	<td style={{ width: '30%', backgroundColor: '#f8f9fa', fontWeight: '500', verticalAlign: 'top' }}>Course Name</td>
																	<td style={{ wordBreak: 'break-word', padding: '0.75rem' }}>{selectedCourse.name || 'N/A'}
																		<input type="hidden" name="courseid" id="courseid" value={selectedCourse.courseid || ''} />
																	</td>
																</tr>
																<tr>
																	<td style={{ backgroundColor: '#f8f9fa', fontWeight: '500', verticalAlign: 'top' }}>Semester</td>
																	<td style={{ wordBreak: 'break-word' }}>{selectedCourse.semester || 'N/A'}</td>
																</tr>
																<tr>
																	<td style={{ backgroundColor: '#f8f9fa', fontWeight: '500', verticalAlign: 'top' }}>Remarks</td>
																	<td style={{ wordBreak: 'break-word' }}>
																		<div style={{ border: '1px solid #b0b1b3', padding: '10px' }}>
																			{selectedCourse.remarks && selectedCourse.remarks.length > 0 ? (
																				<ul className="mb-0 ps-3" style={{ listStyleType: 'disc' }}>
																					{selectedCourse.remarks.map((remark, idx) => (
																						<li key={idx}>
																							<strong>{remark.name}</strong> <em className="text-muted" style={{ fontSize: '0.85em' }}>({remark.timestamp})</em><br />
																							{remark.remark}
																						</li>
																					))}
																				</ul>
																			) : 'N/A'}
																		</div>
																	</td>
																</tr>
																<tr>
																	<td style={{ backgroundColor: '#f8f9fa', fontWeight: '500', verticalAlign: 'top' }}>Add Remark</td>
																	<td>
																		<textarea
																			name="remark"
																			id="remark"
																			className="form-control"
																			rows="3"
																			placeholder="Enter your remark here..."
																			onChange={(event) => setNewRemark(event.target.value)}
																			value={newRemark}
																		/>
																	</td>
																</tr>
																<tr>
																	<td style={{ backgroundColor: '#f8f9fa', fontWeight: '500', verticalAlign: 'top' }}>Status</td>
																	<td style={{ wordBreak: 'break-word' }}>
																		<div
																			className={`badge ${getStatusBadgeClass(selectedCourseStatus)}`}
																			style={{ fontSize: '0.9rem', padding: '0.4em 0.6em' }}
																		>
																			{getStatusText(selectedCourseStatus)}
																		</div>
																	</td>
																</tr>
															</tbody>
														</table>
													)}
												</div>

												<div className="modal-footer" style={{ padding: '0.75rem 1rem', borderTop: '1px solid #dee2e6', backgroundColor: '#e9ecef', position: 'sticky', bottom: 0 }}>
													{selectedCourseStatus === 'aca12_forwarded_to_expert_committee' && (
														<button
															type="button"
															className="btn btn-sm btn-success"
															disabled={actionLoadingId === selectedCourse.id}
															onClick={() => handleApproveCourse(selectedCourse)}
														>
															Recommend to ACA12
														</button>
													)}
													{selectedCourseStatus === 'aca12_forwarded_to_expert_committee' && (
														<button
															type="button"
															className="btn btn-sm btn-danger"
															disabled={actionLoadingId === selectedCourse.id}
															onClick={() => handleRevertCourse(selectedCourse)}
														>
															Revert to Teacher
														</button>
													)}
													<button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => { setShowCourseModal(false); setSelectedCourse(null); setNewRemark(''); }}>
														Close
													</button>
												</div>
											</div>
										</div>
									)}

									{totalPages > 1 && (
										<nav aria-label="pagination" style={{ cursor: 'pointer' }}>
											<ul className="pagination justify-content-center">
												<li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
													<span className="page-link pgn-clr" onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}>
														<i className="bi bi-arrow-left-circle-fill"></i>
													</span>
												</li>

												<li className="page-item">
													<span className="page-link pgn-clr" onClick={() => setCurrentPage(1)}>1</span>
												</li>

												{currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

												{[...Array(totalPages - 1).keys()]
													.slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2)
													.map((pageNumber) => (
														<li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
															<span className="page-link pgn-clr" onClick={() => setCurrentPage(pageNumber + 1)}>
																{pageNumber + 1}
															</span>
														</li>
													))}

												{currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

												<li className="page-item">
													<span className="page-link pgn-clr" onClick={() => setCurrentPage(totalPages)}>{totalPages}</span>
												</li>

												<li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
													<span className="page-link pgn-clr" onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}>
														<i className="bi bi-arrow-right-circle-fill"></i>
													</span>
												</li>
											</ul>
										</nav>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</Template>
		</>
	);
}
